export const CONSTANTS = {
    HTTP_STATUS_WARNING: 575,
} as const;
